import LabeledInput from './labeledInput';

export default LabeledInput;
